import { MapPinIcon, ClipboardDocumentIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import EventMapLocation from './EventMapLocation';

interface EventLocationSectionProps {
  eventData: {
    eventCoOrdinates: { latitude: number; longitude: number };
    eventAddress: string;
  };
}

const EventLocationSection = ({ eventData }: EventLocationSectionProps) => (
  <div className="bg-white p-6 rounded-xl shadow-sm">
    <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
      <MapPinIcon className="w-6 h-6 text-red-600" />
      Event Location
    </h2>
    <div className="h-96 rounded-lg overflow-hidden mb-4">
      {eventData.eventCoOrdinates?.latitude ? (
        <EventMapLocation
          lat={eventData.eventCoOrdinates.latitude}
          lng={eventData.eventCoOrdinates.longitude}
          address={eventData.eventAddress}
        />
      ) : (
        <div className="h-full w-full bg-gray-100 flex items-center justify-center text-gray-500">
          Map not available
        </div>
      )}
    </div>
    <div className="flex flex-wrap gap-3">
      <button
        onClick={() => navigator.clipboard.writeText(eventData.eventAddress)}
        className="flex items-center gap-2 px-4 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 text-gray-700"
      >
        <ClipboardDocumentIcon className="w-5 h-5" />
        Copy Address
      </button>
      <a
        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(eventData.eventAddress)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
      >
        <ArrowTopRightOnSquareIcon className="w-5 h-5" />
        Get Directions
      </a>
    </div>
  </div>
);
export default EventLocationSection